import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDatabase, onValue } from "firebase/database";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ref, set } from "firebase/database";
import { db } from "../firebaseConfig";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import logo from "../assets/logo.png";
import html2canvas from "html2canvas";
import logo1 from "../assets/image1.jpg";
// FontAwesome imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faEnvelope,
  faFilePdf,
  faCheckCircle,
  faCheck,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import SEO from "./SEO";
// Component import
import EnquiryForm from "./CTA";

const DestinationPage = ({ packageDetails }) => {
  const { destinationName } = useParams();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [destinationDisplayName, setDestinationDisplayName] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);

  // States for enquiry form modal
  const [isEnquiryModalOpen, setIsEnquiryModalOpen] = useState(false);
const [enquiryFormData, setEnquiryFormData] = useState({
  name: "",
  email: "",
  mobile: "",
  travellers: "",
  date: "",
  destination: destinationDisplayName || destinationName,
  package: selectedPackage?.name || ""
});

  useEffect(() => {
    const db = getDatabase();
    const allPackagesRef = ref(db, "packages");

    const unsubscribe = onValue(allPackagesRef, (snapshot) => {
      const allData = snapshot.val();
      if (allData) {
        const destinationKeys = Object.keys(allData);
        const matchedKey = destinationKeys.find(
          (key) => key.toLowerCase().replace(/\s+/g, "-") === destinationName
        );

        if (matchedKey) {
          setDestinationDisplayName(matchedKey);
          const destinationData = allData[matchedKey];

          if (destinationData) {
            const packagesArray = Object.keys(destinationData).map(
              (packageName) => ({
                id: packageName,
                ...destinationData[packageName],
              })
            );
            setPackages(packagesArray);
          } else {
            setPackages([]);
          }
        } else {
          setPackages([]);
        }
      } else {
        setPackages([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [destinationName]);

const openEnquiryModal = (pkg = null) => {
  setSelectedPackage(pkg);
  setEnquiryFormData(prev => ({
    ...prev,
    destination: destinationDisplayName || destinationName,
    package: pkg?.name || ""
  }));
  setIsEnquiryModalOpen(true);
};


const closeEnquiryModal = () => {
  setIsEnquiryModalOpen(false);
  setSelectedPackage(null);
};

const handleFormChange = (e) => {
  const { name, value } = e.target;
  setEnquiryFormData(prev => ({
    ...prev,
    [name]: value,
  }));
};


const handleFormSubmit = async (e) => {
  e.preventDefault();

  try {
    // Use timestamp as key for unique entries
    const enquiryRef = ref(db, `enquiries/${Date.now()}`);
    await set(enquiryRef, {
      ...enquiryFormData,
      timestamp: new Date().toISOString(),
      status: "new",
      packageId: selectedPackage?.id || ""
    });

    alert("Your enquiry has been submitted successfully!");

    // Reset form
    setEnquiryFormData({
      name: "",
      email: "",
      mobile: "",
      travellers: "",
      date: "",
      destination: destinationDisplayName || destinationName,
      package: ""
    });
    
    closeEnquiryModal();
  } catch (error) {
    console.error("Error submitting enquiry:", error);
    alert("There was an error submitting your enquiry. Please try again.");
  }
};

  const downloadUploadedPDF = () => {
    if (!selectedPackage?.pdfUrl) {
      alert("No PDF available for this package");
      return;
    }

    const link = document.createElement("a");
    link.href = selectedPackage.pdfUrl;
    const filename =
      selectedPackage.pdfUrl.split("/").pop() ||
      `${selectedPackage.name.replace(/\s+/g, "-")}.pdf`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const TourDetailsModal = ({ tour, onClose }) => {
    const [showEnquiryForm, setShowEnquiryForm] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleImageClick = (img, index) => {
      setSelectedImage(img);
      setCurrentImageIndex(index);
    };

    const navigateImage = (direction) => {
      const newIndex =
        direction === "next"
          ? (currentImageIndex + 1) % tour.images.length
          : (currentImageIndex - 1 + tour.images.length) % tour.images.length;

      setSelectedImage(tour.images[newIndex]);
      setCurrentImageIndex(newIndex);
    };



    const generatePDF = async () => {
      if (!tour) return;

      const TOP_MARGIN = 20;
      const BOTTOM_MARGIN = 275;

      // ✅ Word wrap helper — wraps by word count instead of width
      function wrapTextByWords(text, wordsPerLine = 9) {
        if (!text) return [];
        const words = text.split(/\s+/);
        let lines = [];
        for (let i = 0; i < words.length; i += wordsPerLine) {
          lines.push(words.slice(i, i + wordsPerLine).join(" "));
        }
        return lines;
      }

      const ensureSafeY = (requiredSpace = 10) => {
        if (yPosition + requiredSpace > BOTTOM_MARGIN) {
          doc.addPage();
          yPosition = TOP_MARGIN;
        }
      };

      // Load logo
      const img = new Image();
      img.src = logo1;
      await new Promise((resolve) => (img.onload = resolve));

      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image1/png");

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      let yPosition = 10;

      // LOGO
      const logoWidth = 200;
      const logoHeight = 100;
      const centerX = 105 - logoWidth / 2;
      doc.addImage(dataURL, "PNG", centerX, yPosition, logoWidth, logoHeight);
      yPosition += logoHeight + 5;

      // HEADER
      

      // PACKAGE TITLE
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
      yPosition += 15;

      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 10;

      // PACKAGE DETAILS
      ensureSafeY(40);
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text(tour.name.toUpperCase(), 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "normal");
      doc.text(`Destination: ${tour.destination}`, 20, yPosition);
      yPosition += 7;
      doc.text(`Duration: ${tour.duration}`, 20, yPosition);
      yPosition += 7;


    // PRICES SECTION
        // PRICES SECTION - Left aligned
    doc.setFontSize(12);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("PRICE DETAILS", 20, yPosition);
    yPosition += 7;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (tour.priceValues && typeof tour.priceValues === 'object' && Object.keys(tour.priceValues).length > 0) {
      doc.setFillColor(241, 243, 245);
      doc.rect(15, yPosition, 180, 8, "F");
      
      doc.setFontSize(10);
      doc.setTextColor(30, 58, 138);
      doc.text("Price Breakdown", 20, yPosition + 6);
      yPosition += 15;

      Object.entries(tour.priceValues).forEach(([priceType, priceValue]) => {
        ensureSafeY(10);
        
        let numericValue;
        if (typeof priceValue === 'number' || typeof priceValue === 'string') {
          numericValue = priceValue;
        } else if (typeof priceValue === 'string') {
          const cleanedValue = priceValue.replace(/[^\d.-]/g, '');
          numericValue = parseFloat(cleanedValue) || 0;
        } else {
          numericValue = 0;
        }
        
        const formattedPrice = `₹${numericValue.toLocaleString('en-IN')}`;
        
        // Left-aligned price listing
        doc.text(`${priceType}: ${formattedPrice}`, 20, yPosition);
        yPosition += 8;
        
        if (yPosition < BOTTOM_MARGIN - 10) {
          doc.setDrawColor(220, 220, 220);
          doc.setLineWidth(0.2);
          doc.line(25, yPosition, 190, yPosition);
          yPosition += 5;
        }
      });
      
      if (tour.totalPrice) {
        ensureSafeY(15);
        doc.setFont("helvetica", "bold");
        doc.text("Total Package Price:", 20, yPosition);
        const totalFormatted = `₹${Number(tour.totalPrice)?.toLocaleString('en-IN') || "0"}`;
        doc.text(totalFormatted, 60, yPosition);
        yPosition += 10;
      }
    } else {
      doc.text("No pricing information available", 20, yPosition);
      yPosition += 7;
    }

    yPosition += 10;

      // DESCRIPTION
      ensureSafeY(20);
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DESCRIPTION", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      const descriptionLines = wrapTextByWords(
        tour.description || "No description available",
        9
      );
      ensureSafeY(descriptionLines.length * 6 + 15);
      doc.text(descriptionLines, 20, yPosition);
      yPosition += descriptionLines.length * 6 + 15;

      // ITINERARY
      if (
        tour.itinerary &&
        typeof tour.itinerary === "object" &&
        Object.keys(tour.itinerary).length > 0
      ) {
        doc.addPage();
        yPosition = TOP_MARGIN;

        doc.setFontSize(16);
        doc.setTextColor(30, 58, 138);
        doc.setFont("helvetica", "bold");
        doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
        yPosition += 15;

        Object.entries(tour.itinerary).forEach(([dayTitle, description]) => {
          const descLines = wrapTextByWords(description, 10);
          ensureSafeY(10 + descLines.length * 6 + 10);

          doc.setFillColor(241, 243, 245);
          doc.rect(15, yPosition, 180, 8, "F");
          doc.setFontSize(14);
          doc.setTextColor(30, 58, 138);
          doc.text(dayTitle, 20, yPosition + 6);
          yPosition += 10;

          doc.setFontSize(12);
          doc.setTextColor(50, 50, 50);
          doc.text(descLines, 20, yPosition + 5);
          yPosition += descLines.length * 6 + 10;
        });
      }

      // INCLUSIONS
      doc.addPage();
      yPosition = TOP_MARGIN;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("INCLUSIONS", 20, yPosition);
      yPosition += 10;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");

      if (tour.includes && typeof tour.includes === "object") {
        Object.values(tour.includes).forEach((item) => {
          const lines = wrapTextByWords(item, 10);
          ensureSafeY(lines.length * 6 + 5);
          doc.text(`• ${lines[0]}`, 25, yPosition);
          for (let i = 1; i < lines.length; i++) {
            yPosition += 6;
            doc.text(lines[i], 30, yPosition);
          }
          yPosition += 7;
        });
      } else {
        doc.text("No inclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      yPosition += 10;

      // EXCLUSIONS
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("EXCLUSIONS", 20, yPosition);
      yPosition += 10;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");

      if (tour.excludes && typeof tour.excludes === "object") {
        Object.values(tour.excludes).forEach((item) => {
          const lines = wrapTextByWords(item, 10);
          ensureSafeY(lines.length * 6 + 5);
          doc.text(`• ${lines[0]}`, 25, yPosition);
          for (let i = 1; i < lines.length; i++) {
            yPosition += 6;
            doc.text(lines[i], 30, yPosition);
          }
          yPosition += 7;
        });
      } else {
        doc.text("No exclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // TERMS & CONDITIONS
      if (tour.termsAndConditions) {
        doc.addPage();
        yPosition = TOP_MARGIN;
        doc.setFontSize(16);
        doc.setTextColor(30, 58, 138);
        doc.setFont("helvetica", "bold");
        doc.text("TERMS & CONDITIONS", 105, yPosition, { align: "center" });
        yPosition += 15;
        doc.setFontSize(11);
        doc.setTextColor(80, 80, 80);
        doc.setFont("helvetica", "normal");

        const termsLines = wrapTextByWords(tour.termsAndConditions, 4);
        ensureSafeY(termsLines.length * 6 + 10);
        doc.text(termsLines, 20, yPosition);
      }

      // FOOTER
      const pageCount = doc.internal.getNumberOfPages();
      const footerY = 287;
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(15, footerY - 5, 195, footerY - 5);
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Page ${i} of ${pageCount}`, 105, footerY, {
          align: "center",
        });
        doc.text("Pearl Tours & Travels", 20, footerY);
        doc.text(new Date().toLocaleDateString(), 190, footerY, {
          align: "right",
        });
      }

      doc.save(`${tour.name.replace(/\s+/g, "_")}_package_details.pdf`);
    };

    if (!tour) return null;

    return (
      <>
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          <div className="modal-container">
            <button className="modal-close-btn" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className="modal-header">
              <h2>{tour.name}</h2>
              <div className="modal-subheader">
                <span className="modal-location">
                  <i className="fas fa-map-marker-alt"></i> {tour.destination}
                </span>
                <span className="modal-duration">
                  <i className="far fa-clock"></i> {tour.duration}
                </span>
                <span className="modal-rating">
                  {"★".repeat(tour.rating || 5)}
                  {"☆".repeat(5 - (tour.rating || 5))} ({tour.rating || 5}.0)
                </span>
              </div>
            </div>

            {/* <div className="modal-image-gallery">
              <div className="main-image">
                <img 
                  src={tour.images?.[0] || "https://via.placeholder.com/800x500?text=No+Image"} 
                  alt={tour.name} 
                />
              </div>
              <div className="thumbnail-container">
                {(tour.images || []).slice(0, 4).map((img, index) => (
                  <div key={index} className="thumbnail">
                    <img src={img} alt={`${tour.name} ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div> */}

            <div className="modal-image-gallery">
              <div className="main-image">
                <img
                  src={
                    tour.images?.[0] ||
                    "https://via.placeholder.com/800x500?text=No+Image"
                  }
                  alt={tour.name}
                  onClick={() =>
                    tour.images?.[0] && handleImageClick(tour.images[0], 0)
                  }
                />
              </div>
              <div className="thumbnail-container">
                {(tour.images || []).slice(0, 4).map((img, index) => (
                  <div
                    key={index}
                    className="thumbnail"
                    onClick={() => handleImageClick(img, index)}
                  >
                    <img src={img} alt={`${tour.name} ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-content">
              <div className="modal-price-section">
                <div className="price-box">
                  <span className="itinerary">
                    Description : <br />
                    {tour.description}
                  </span>
                  <span className="price-label">Starting from</span>
                  <span className="price-amount">
                      {(
      tour.priceValues?.[Object.keys(tour.priceValues)?.[0]] || 0
    ).toLocaleString('en-IN')}
                  </span>
                  <span className="price-per">{tour.priceType || " "}</span>
                  <button
                    className="enquiry-now-btn"
                   onClick={() => openEnquiryModal(true)}
                  >
                    <FontAwesomeIcon icon={faEnvelope} /> Enquiry Now
                  </button>

                  <button className="download-pdf-btn" onClick={generatePDF}>
                    <FontAwesomeIcon icon={faFilePdf} /> Download PDF
                  </button>
                </div>
              </div>

              <div className="modal-details-section">
                {/* <h3>Package Highlights</h3> */}
                <ul className="highlights-list">
                  {(tour.highlights || []).map((item, index) => (
                    <li key={index}>
                      <FontAwesomeIcon icon={faCheckCircle} /> {item}
                    </li>
                  ))}
                </ul>

                <h3 style={{ color: "#64192e" }}>Detailed Itinerary</h3>
                <div className="itinerary">
                  {tour.itinerary && typeof tour.itinerary === "object" ? (
                    Object.entries(tour.itinerary).map(
                      ([dayTitle, description], index) => (
                        <div key={index} className="day-plan">
                          <h4>{dayTitle}</h4>
                          <p>{description}</p>
                        </div>
                      )
                    )
                  ) : (
                    <p>No detailed itinerary available.</p>
                  )}
                </div>

                <h3>Inclusions</h3>
                <ul className="inclusions-list">
                  {tour.includes && typeof tour.includes === "object" ? (
                    Object.values(tour.includes).map((item, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faCheck} /> {item}
                      </li>
                    ))
                  ) : (
                    <li>No inclusions listed.</li>
                  )}
                </ul>

                <h3>Exclusions</h3>
                <ul className="exclusions-list">
                  {tour.excludes && typeof tour.excludes === "object" ? (
                    Object.values(tour.excludes).map((item, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faTimes} /> {item}
                      </li>
                    ))
                  ) : (
                    <li>No exclusions listed.</li>
                  )}
                </ul>

                {tour.termsAndConditions && (
                  <>
                    <h3>Terms & Conditions</h3>
                    <p className="terms">{tour.termsAndConditions}</p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {selectedImage && (
          <div
            className="image-popup-overlay"
            onClick={() => setSelectedImage(null)}
          >
            <div
              className="image-popup-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="popup-close-btn"
                onClick={() => setSelectedImage(null)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>

              {tour.images.length > 1 && (
                <>
                  <button
                    className="nav-btn prev-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigateImage("prev");
                    }}
                  >
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <button
                    className="nav-btn next-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigateImage("next");
                    }}
                  >
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </>
              )}

              <img
                src={selectedImage}
                alt="Enlarged view"
                className="popup-image"
              />

              <div className="image-counter">
                {currentImageIndex + 1} / {tour.images.length}
              </div>
            </div>
          </div>
        )}

        {showEnquiryForm && (
          <EnquiryForm onClose={() => setShowEnquiryForm(false)} tour={tour} />
        )}
      </>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          background: "linear-gradient(135deg, #eb0e0eff 0%, #e9120eff 100%)",
        }}
      >
        {/* Logo with rotation and pulse animation */}
        <div
          style={{
            width: "100px",
            height: "100px",
            marginBottom: "25px",
            animation: "rotateAndPulse 2s infinite ease-in-out",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Company logo image */}
          <img
            src={logo}
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              objectFit: "contain",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            }}
            alt="Company Logo"
          />
        </div>

        {/* Progress bar */}
        <div
          style={{
            width: "220px",
            height: "6px",
            backgroundColor: "rgba(255,255,255,0.3)",
            borderRadius: "3px",
            overflow: "hidden",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "white",
              borderRadius: "3px",
              animation: "progress 2s infinite ease-in-out",
            }}
          ></div>
        </div>

        <p
          style={{
            color: "white",
            fontSize: "18px",
            fontWeight: "500",
            textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            marginBottom: "10px",
          }}
        >
          Loading packages...
        </p>

        <p
          style={{
            color: "rgba(255,255,255,0.8)",
            fontSize: "14px",
            fontStyle: "italic",
          }}
        >
          Almost there
        </p>

        <style>{`
    @keyframes rotateAndPulse {
      0% { transform: rotate(0deg) scale(1); }
      50% { transform: rotate(180deg) scale(1.1); }
      100% { transform: rotate(360deg) scale(1); }
    }
    @keyframes progress {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `}</style>
      </div>
    );
  }

  return (
    <>
        <SEO
        title="Destination Details | Pearl Tours & Travels"
        description="Explore details about top destinations for your next trip with Pearl Tours & Travels."
        keywords="travel destinations, Paris tour, Bali travel, Maldives holiday packages, Europe trips"
      />
      <Navbar />
      <div className="destination-page">
        <h1
          style={{
            textAlign: "center",
            margin: "30px 0",
            fontSize: "2.5rem",
            color: "#2c3e50",
          }}
        >
          {destinationDisplayName || destinationName} Tour Packages
        </h1>

        {packages.length === 0 ? (
          <div className="no-packages">
            <img
              src="/images/no-packages.svg"
              alt="No packages"
              style={{ width: "200px" }}
            />
            <p
              style={{
                textAlign: "center",
                fontSize: "1.2rem",
                marginTop: "20px",
              }}
            >
              No packages found for this destination
            </p>
          </div>
        ) : (
          <div className="packages-container">
            {packages.map((pkg) => (
              <div key={pkg.id} className="package-card">
                {pkg.images && pkg.images.length > 0 && (
                  <div className="package-image-main">
                    <img src={pkg.images[0]} alt={pkg.name} />
                  </div>
                )}

                <div className="package-content">
                  <h2>{pkg.name}</h2>
                  <div className="package-highlights">
                    <div className="highlight-item">
                      <span className="highlight-icon">📍</span>
                      <span>{pkg.destination}</span>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">⏳</span>
                      <span>{pkg.duration}</span>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">💰</span>
                      <span>    {(
      pkg.priceValues?.[Object.keys(pkg.priceValues)?.[0]] || 0
    ).toLocaleString('en-IN')}</span>
                    </div>
                  </div>

                  <p className="package-description">
                    {pkg.description.length > 150
                      ? `${pkg.description.substring(0, 150)}...`
                      : pkg.description}
                  </p>

                  <button
                    className="view-btn"
                    onClick={() => setSelectedPackage(pkg)}
                  >
                    <i className="far fa-eye"></i> View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedPackage && (
        <TourDetailsModal
          tour={selectedPackage}
          onClose={() => setSelectedPackage(null)}
        />
      )}

   {isEnquiryModalOpen && (
  <div className="enquiry-modal-overlay" onClick={closeEnquiryModal}>
    <div
      className="enquiry-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button className="close-btn" onClick={closeEnquiryModal}>
        &times;
      </button>

      <div className="modal-header">
        <h2>{selectedPackage ? `Enquire About ${selectedPackage.name}` : "Send us a Query"}</h2>
        <p>
          Ready to venture out into the world? Fill the form below and
          start your brand new journey with us
        </p>
      </div>

      <form onSubmit={handleFormSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name*</label>
          <input
            type="text"
            id="name"
            name="name"
            value={enquiryFormData.name}
            onChange={handleFormChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email*</label>
          <input
            type="email"
            id="email"
            name="email"
            value={enquiryFormData.email}
            onChange={handleFormChange}
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="mobile">Mobile*</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={enquiryFormData.mobile}
              onChange={handleFormChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="travellers">No of travellers*</label>
            <input
              type="number"
              id="travellers"
              name="travellers"
              min="1"
              value={enquiryFormData.travellers}
              onChange={handleFormChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="date">Date*</label>
            <input
              type="date"
              id="date"
              name="date"
              value={enquiryFormData.date}
              onChange={handleFormChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="destination">Destination*</label>
            <input
              type="text"
              id="destination"
              name="destination"
              value={enquiryFormData.destination}
              onChange={handleFormChange}
              readOnly
            />
          </div>
        </div>
{/* 
        {selectedPackage && (
          <div className="form-group">
            <label htmlFor="package">Package</label>
            <input
              type="text"
              id="package"
              name="package"
              value={enquiryFormData.package}
              onChange={handleFormChange}
              readOnly
            />
          </div>
        )} */}

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  </div>
)}

      <style>
        {`
          .destination-page {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
          }
          
          .no-packages {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
          }
          
          .packages-container {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
            gap: 30px;
            margin-top: 30px;
          }
          
          .package-card {
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            margin-bottom: 80px;
          }
          
          .package-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 20px rgba(0, 0, 0, 0.120);
          }
          
          .package-image-main {
            height: 200px;
            overflow: hidden;
          }
          
          .package-image-main img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
          }
          
          .package-card:hover .package-image-main img {
            transform: scale(1.05);
          }
          
          .package-content {
            padding: 20px;
          }
          
          .package-card h2 {
            color: #2c3e50;
            margin: 0 0 15px 0;
            font-size: 1.5rem;
          }
          
          .package-highlights {
            display: flex;
            gap: 15px;
            margin-bottom: 15px;
            flex-wrap: wrap;
          }
          
          .highlight-item {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 0.9rem;
            color: #7f8c8d;
          }
          
          .highlight-icon {
            font-size: 1.1rem;
          }
          
          .package-description {
            color: #34495e;
            line-height: 1.5;
            margin-bottom: 20px;
          }
          
          .view-btn {
           flex: 1;
          padding: 0.7rem;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          background: var(--light);
          color: var(--dark);
          border: 1px solid #641a2e;
          }
          
          .view-btn:hover {
          background: #64192e;
          color: white;
          }
          
          /* Modal Styles */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            padding: 20px;
          }
          
          .modal-container {
            background: white;
            border-radius: 12px;
            max-width: 900px;
            width: 100%;
            max-height: 90vh;
            overflow-y: auto;
            position: relative;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          }
          
          .modal-close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: #7f8c8d;
            z-index: 10;
          }
          
          .modal-header {
            padding: 25px;
            border-bottom: 1px solid #ecf0f1;
          }
          
          .modal-header h2 {
            margin: 0;
            color: #2c3e50;
            font-size: 1.8rem;
          }
          
          .modal-subheader {
            display: flex;
            gap: 15px;
            margin-top: 10px;
            flex-wrap: wrap;
          }
          
          .modal-subheader span {
            display: flex;
            align-items: center;
            gap: 5px;
            font-size: 0.9rem;
            color: #7f8c8d;
          }
          
          .modal-image-gallery {
            padding: 0 25px;
            margin: 20px 0;
          }
          
          .main-image {
            height: 350px;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 10px;
          }
          
          .main-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          
          .thumbnail-container {
            display: flex;
            gap: 10px;
          }
          
          .thumbnail {
            width: 80px;
            height: 60px;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
          }
          
          .thumbnail img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          
          .modal-content {
            display: flex;
            padding: 0 25px 25px;
            gap: 30px;
          }
          
          .modal-price-section {
            flex: 0 0 300px;
          }
          
          .price-box {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 20px;
            position: sticky;
            top: 20px;
          }
          
          .price-label {
            display: block;
            font-size: 0.9rem;
            color: #7f8c8d;
            margin-top: 10px;
          }
          
          .price-amount {
            display: block;
            font-size: 1.2rem;
            font-weight: bold;
            color: #2c3e50;
          }
          
          .price-per {
            display: block;
            font-size: 0.9rem;
            color: #7f8c8d;
            margin-bottom: 20px;
          }
          
          .enquiry-now-btn, .download-pdf-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            width: 100%;
            padding: 12px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-bottom: 10px;
          }
          
          .enquiry-now-btn {
              width: 100%;
          padding: 0.8rem;
          background: #64192e;
          color: white;
          border: none;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          }
          
          .enquiry-now-btn:hover {
              background: #ffffffff;
          color: var(--primary);
          border: 1px solid #641a2e;
          }
          
          .download-pdf-btn {
             width: 100%;
          padding: 0.8rem;
          background: #ffffffff;
          color: #64192e;
          border: 1px solid  #64192e;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1rem;
          }
          
          .download-pdf-btn:hover {
             background: #64192e;
          color: white;
          border: 1px solid var(--primary);
          }
          
          .modal-details-section {
            flex: 1;
          }

       
          
          .modal-details-section h3 {
            color: #3498db;
            margin: 25px 0 15px 0;
            font-size: 1.3rem;
          }
          
          .highlights-list, .inclusions-list, .exclusions-list {
            list-style: none;
            padding: 0;
            margin: 0 0 20px 0;
          }
          
          .highlights-list li, .inclusions-list li, .exclusions-list li {
            margin-bottom: 8px;
            display: flex;
            align-items: flex-start;
            gap: 8px;
          }
          
          .day-plan {
            margin-bottom: 20px;
          }
          
          .day-plan h4 {
            margin: 0 0 8px 0;
            color: #2c3e50;
          }
          
          .day-plan p {
            margin: 0;
            color: #34495e;
            line-height: 1.5;
          }
          
          .terms {
            color: #34495e;
            line-height: 1.5;
          }
          
          /* Enquiry Form Modal Styles */
          .enquiry-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            padding: 20px;
          }
          
          .enquiry-modal-content {
            background: white;
            border-radius: 12px;
            max-width: 600px;
            width: 100%;
            padding: 30px;
            position: relative;
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          }
          
          .close-btn {
            position: absolute;
            top: 15px;
            right: 20px;
            background: none;
            border: none;
            font-size: 2rem;
            color: #888;
            cursor: pointer;
            transition: color 0.2s;
          }
          
          .close-btn:hover {
            color: #ff6b35;
          }
          
          .modal-header {
            margin-bottom: 20px;
          }
          
          .modal-header h2 {
            margin: 0 0 10px 0;
            color: #2c3e50;
          }
          
          .modal-header p {
            margin: 0;
            color: #7f8c8d;
          }
          
          .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 15px;
          }
          
          .form-row {
            display: flex;
            gap: 20px;
          }
          
          .form-row .form-group {
            flex: 1;
          }
          
          label {
            font-weight: 600;
            color: #444;
            font-size: 0.95rem;
          }
          
          input {
            padding: 14px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 1rem;
            transition: all 0.2s;
          }
          
          input:focus {
            outline: none;
            border-color: #ff6b35;
            box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.2);
          }
          
          input[readonly] {
            background-color: #f5f5f5;
            cursor: not-allowed;
          }
          
          .submit-btn {
            background: #ff6b35;
            color: white;
            border: none;
            padding: 15px;
            font-size: 1.1rem;
            font-weight: 600;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s;
            margin-top: 10px;
            width: 100%;
          }
          
          .submit-btn:hover {
            background: #ff7d4d;
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(255, 107, 53, 0.4);
          }
          
          /* Responsive adjustments */
          @media (max-width: 768px) {
            .packages-container {
              grid-template-columns: 1fr;
            }
            
            .modal-content {
              flex-direction: column;
            }
            
            .modal-price-section {
              flex: 1;
            }
            
            .main-image {
              height: 250px;
            }
            
            .form-row {
              flex-direction: column;
              gap: 0;
            }
          }
          
          @media (max-width: 480px) {
            .modal-subheader {
              flex-direction: column;
              gap: 5px;
            }
            
            .modal-image-gallery {
              padding: 0 15px;
            }
            
            .main-image {
              height: 200px;
            }
            
            .modal-content {
              padding: 0 15px 15px;
            }
          }


          /* Image Popup Styles */
.image-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.image-popup-container {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  text-align: center;
}

.popup-image {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  margin: 0 auto;
}

.popup-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 60px;
  cursor: pointer;
  z-index: 1001;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.image-counter {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
}

/* Make gallery images clickable */
.main-image img,
.thumbnail img {
  cursor: pointer;
  transition: transform 0.3s;
}

.main-image img:hover,
.thumbnail img:hover {
  transform: scale(1.02);
}

.thumbnail-container {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.thumbnail {
  width: 25%;
  cursor: pointer;
}

.thumbnail img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
  aspect-ratio: 1/1;
}


        `}
      </style>
      <Footer />
    </>
  );
};

export default DestinationPage;
